/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
//////
import React, {
    useEffect,
    useState,
    Fragment,
} from "react";
//////
import "./assets/bulma.css";
import "./assets/tailwind.min.css";
import {
    PopupManagePageState,
    WalletItemProps
} from "interfaces/wallet";
import { _Wallet } from '../../types';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { checkAuthenticated, userSelector } from '../user/userSlice';
import ApiSingWallet from "libs/apiSingWallet";
import { Box, Card, CircularProgress, IconButton, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { pathRoutes } from '../../libs/constans';
import { changePopupWalletSelected, getRatioBNBSING } from "./popupSlice";

function WalletItem({ item, api_root, bearer_token }: WalletItemProps) {

    const dispatch = useAppDispatch();
    const history = useHistory();

    const WalletInfo = () => {

        const showBalance = item.balance ? <Fragment>{item.balance.balance} <strong>{item.balance.symbol}</strong></Fragment> : <Fragment></Fragment>

        return <Fragment>
            <Box>
                <Typography sx={{ fontSize: '20px', fontWeight: '500' }}>{item.description}</Typography>
                <Typography sx={{ fontSize: '14px' }} >{showBalance}</Typography>
            </Box>
        </Fragment >
    }

    const handleClick = () => {

        dispatch(changePopupWalletSelected(item));

        history.push(pathRoutes.WALLET_DETAILS + `/${item.id}?walletName=${item.description}`)
    }

    if ("ETHEREUM" === item.secretType) {
        return <Fragment>
            <Card  sx={{ backgroundColor: '#242B43', borderRadius: '8px', mb: 2, p: 2 }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                    onClick={handleClick}
                >
                    <Box sx={{ mr: 2 }}>
                        <i className="fab fa-ethereum bm-has-text-link" style={{ fontSize: '50px' }} />
                    </Box>
                    <WalletInfo />
                </Box>
            </Card>
        </Fragment>
    }


    return <Fragment>
        <Card sx={{ backgroundColor: '#242B43', borderRadius: '8px', mb: 2, p: 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
                onClick={handleClick}
            >
                <Box sx={{ mr: 2 }}>
                    <object data={`${api_root}/static/assets/bnb-coin.svg`} width={50} height={50}> </object>
                </Box>
                <WalletInfo />
            </Box>
        </Card>
    </Fragment>

}


export default function PopupWalletManage(props: any) {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let data = urlParams.get('data');


    const dispatch = useAppDispatch();

    const [userWallets, setUserWallets] = useState<_Wallet[]>([]);
    const [pending, setPending] = useState(false);

    const { tokenBearer, user, isLoggedIn, isLoading } = useAppSelector(userSelector);
    const api = new ApiSingWallet()

    const getWallets = async () => {
        setPending(true);
        await api.getListWallet(tokenBearer).then(
            (result) => {
                setUserWallets(result.result)
            },
            (error) => {
                console.log(error!.message)
            }
        )
        setPending(false);
    }

    useEffect(() => {
        if (data) {
            console.log("Check authenticate");
            dispatch(checkAuthenticated(data));
        }
    }, [])

    useEffect(() => {
        if (!pending && isLoggedIn) {
            getWallets();
            dispatch(getRatioBNBSING());
        }
    }, [isLoggedIn])


    if (!isLoggedIn && !isLoading) {
        return <div className="">
            <h1 className="bm-title bm-is-primary bm-is-4 mt-4">Invalid Data</h1>
        </div>
    }



    const WalletList = () => {

        const wallets = userWallets.length > 0 ? userWallets.map((walletItem: _Wallet, index: number) => {
            return <WalletItem
                item={walletItem}
                bearer_token={tokenBearer}
                api_root={process.env.REACT_APP_API}
            />
        }) : <Fragment></Fragment>;

        return <Fragment>
            <div id="wallets">
                {wallets}
            </div>
        </Fragment>
    }


    if (PopupManagePageState.WalletListing === "wallet-listing") {
        return <Fragment>
            <div id="wallet-listing" style={{ paddingTop: 12 }}>
                <WalletNav title="SING WALLETS" />

                <WalletList />
                {pending &&
                    <Box sx={{ textAlign: 'center' }}>
                        <CircularProgress />
                    </Box>
                }
            </div>
        </Fragment>

    }

    return <Fragment></Fragment>
}

export function WalletNav({ title }, { title: string }) {
    const history = useHistory()


    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 4
            }}
        >
            <IconButton>
            </IconButton>
            {/* <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{title}</Typography> */}
            <Box
                sx={{
                    height: 35,
                    '& img':{
                        height: '100%',
                    }
                }}
            >
                <img src='/assets/img/logo.svg' alt=''/>
            </Box>
            <IconButton >

            </IconButton>
        </Box>
    );
}